// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'

// If any of the settings we just fetched were empty,
// then display a warning to the user which tells them the settings did not load properly.
// This should really only happen if there was an error during a JPA update.
// This error should never be visible in production but will save a lot of heartache
// by pointing to the empty lookup table as the problem and not a UI issue.

const catchEmptySettings = (setName, newSettings) => (dispatch, getState) => {
  const err = Object.keys(newSettings).reduce((a, k, i) => {
    if (!newSettings[k].length) {
      a.message += `${k} - loaded with no values. \n`
    }
    return a
  }, { message: '' })

  if (err.message.length) {
    dispatch(settingsFailedToLoadMessage(setName, err))
  }
}

export default catchEmptySettings
